<template>
<div>
  <div class="scrollview" :class="{ featured: this.featured }">
    <div class="scrollview-header">{{ title }}</div>
    <component :is="this.componentName" :cardType="this.cardType" :platelist="this.platelist" :swipeable="true" />
  </div>
</div>
</template>

<script>
import store from '@state/store';
import FeaturedCard from '../Featured/FeaturedCard';
import MealCard from '../MealCard/MealCard';

export default {
  components: {
    FeaturedCard,
    MealCard,
  },
  props: {
    cardType: {
      type: String,
      required: false,
    },
    componentName: {
      type: String,
      required: true,
    },
    featured: {
      type: Boolean,
      required: false,
    },
    isEmbed: {
      type: Boolean,
      required: false,
    },
    platelist: {
      type: Array,
      required: false,
    },
    title: {
      type: String,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
@import 'theme.scss';

.scrollview {
  margin-bottom: 1.5rem;
  padding: 1rem 0 0 2rem;

  .scrollview-header {
    color: $color-scrollview-header-text;
    font-size: 1.8rem;
    font-weight: 800;
    margin-bottom: 1rem;
    text-transform: capitalize;
  }

  &.featured {
    .scrollview-header {
      color: $color-featured-scrollview-header-text;
      font-size: 1rem;
      margin-bottom: 0.5rem;
      text-transform: uppercase;
    }
  }
}
</style>
